import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import {
  SortableContainer,
  SortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";
import { IMAGE_PATH, COMMON_FAIL_MESSAGE } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  handleLessonModal,
  courseCurrentChapterOpen,
  updateTemporaryChapterRanking,
  updateSortedChapter,
  fetchAllUnpublishedCourses,
  fetchQuiz,
} from "CourseAction";
import CourseChapters from "./course-chapter-list";
import AddLesson from "./add-lesson";
import LocaleStrings from "Languages";

// userd for sort content list
const DragHandle = sortableHandle(() => (
  <div className="drag_container">
    <img
      src="../../style/images/drag_sign.png"
      className="drag_sign_image mt-20"
    />
  </div>
));
const SortableItem = SortableElement(
  ({
    value,
    sortIndex,
    stepName,
    lessons,
    step,
    displayChild,
    source,
    finishOperationsCallback,
  }) => (
    <div className="col-md-12 d-flex">
      <DragHandle />
      <CourseChapters
        printItem={value}
        stepName={stepName}
        lessons={lessons}
        step={step}
        displayChild={displayChild}
        source={source}
        finishOperationsCallback={finishOperationsCallback}
      />
    </div>
  )
);
const SortableList = SortableContainer(
  ({ items, currentStep, lessons, source, finishOperationsCallback }) => {
    return (
      <div className="row chapter-list-group">
        {items.map((value, index) => {
          let stepName = `step_${index}`;
          let step = LocaleStrings.button_expand;
          let displayChild = false;

          if (currentStep != "" && currentStep == stepName) {
            step = LocaleStrings.button_close;
            displayChild = true;
          }
          let chapterLessons = _.filter(lessons, (obj) => {
            return obj.chapterid == value.chapterid;
          });
          let chapterWiseLesson = _.sortBy(chapterLessons, [
            "ranking",
            "createdon",
          ]);

          return (
            <SortableItem
              key={`course_key_${index}`}
              index={index}
              value={value}
              stepName={stepName}
              lessons={chapterWiseLesson}
              step={step}
              displayChild={displayChild}
              source={source}
              finishOperationsCallback={finishOperationsCallback}
            />
          );
        })}
      </div>
    );
  }
);

class CourseLessonsDetails extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchQuiz(this.props.session);
    this.props.courseCurrentChapterOpen({ currentStep: "" });
  }

  openModel = (e) => {
    var key = e.currentTarget.attributes["data-key"].value;
    this.props.handleLessonModal({ showModal: true, lessonType: key });
  };

  finishOperationsCallback = () => {
    let { callfrom } = this.props;
    if (callfrom === "courses_list") {
      this.props.finishOperationsCallback();
    }
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    let { session, chapters, initialValues, callfrom } = this.props;
    var courseid = initialValues.courseid;
    chapters = arrayMove(chapters, oldIndex, newIndex);

    var newArrAvailable = [];

    //Just map the array and reset the taborder as now taborder is same as the object position
    chapters.map((value, index) => {
      newArrAvailable.push({ ...value, ranking: index + 1 });
    });

    this.props.updateTemporaryChapterRanking(newArrAvailable);

    this.props.updateSortedChapter(session, newArrAvailable, (response) => {
      this.props.fetchAllUnpublishedCourses(session, courseid, (res) => {
        this.props.updateTemporaryChapterRanking({});

        if (callfrom === "courses_list") {
          this.props.finishOperationsCallback();
        }
      });
    });
  };

  renderChapters = () => {
    var { chapters, lessons, source, currentChapterOpen } = this.props;
    var currentStep = currentChapterOpen.currentStep;

    return _.map(chapters, (item, index) => {
      let stepName = `step_${index}`;
      let step = LocaleStrings.button_expand;
      let displayChild = false;

      if (currentStep != "" && currentStep == stepName) {
        step = LocaleStrings.button_close;
        displayChild = true;
      }

      let chapterLessons = _.filter(lessons, (obj) => {
        return obj.chapterid == item.chapterid;
      });
      let chapterWiseLesson = _.sortBy(chapterLessons, [
        "ranking",
        "createdon",
      ]);

      return (
        <div key={`course_key_${index}`} className="col-md-12">
          <CourseChapters
            printItem={item}
            stepName={stepName}
            lessons={chapterWiseLesson}
            step={step}
            displayChild={displayChild}
            source={source}
          />
        </div>
      );
    });
  };

  render() {
    var {
      editMode,
      initialValues,
      source,
      courseLessonModal,
      chapters,
      lessons,
      currentChapterOpen,
    } = this.props;

    return (
      <div>
        {source == "main-page" ? (
          <div>
            {chapters && chapters.length > 0 ? (
              <SortableList
                useDragHandle
                onSortEnd={this.onSortEnd}
                items={chapters}
                lessons={lessons}
                currentStep={currentChapterOpen.currentStep}
                source={source}
                finishOperationsCallback={this.finishOperationsCallback}
                //pressDelay={200}
                lockAxis="y"
              />
            ) : (
              <div className="blank-chapter-div">
                {LocaleStrings.course_chapter_text_no_chapter_added}
              </div>
            )}
            <div className="mt-20 text-right">
              <Button
                className="btn btn-custom-blue"
                data-key="new-chapter"
                onClick={this.openModel}
              >
                {LocaleStrings.button_add_new_chapter}
              </Button>
            </div>
          </div>
        ) : (
          <div className="row chapter-list-group">{this.renderChapters()}</div>
        )}

        {courseLessonModal && courseLessonModal.showModal ? (
          <AddLesson finishOperationsCallback={this.finishOperationsCallback} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  var toEdit = false;
  var initVals = {};
  var chapters = [];
  var lessons = [];

  if (
    state.allUnpublishedCourseList &&
    state.allUnpublishedCourseList.count > 0
  ) {
    initVals = state.allUnpublishedCourseList.resource[0];
    chapters = _.sortBy(
      state.allUnpublishedCourseList.resource[0].course_chapter_by_courseid,
      ["ranking", "createdon"]
    );
    lessons =
      state.allUnpublishedCourseList.resource[0].course_lessons_by_courseid;
  }

  // this temporary chapter ranking is user for quick display sorted chaptersin UI and later it comes from db and again keep the tempCHpaterRanking as ''.
  if (state.tempChapterRanking && state.tempChapterRanking.length > 0) {
    chapters = state.tempChapterRanking;
  }

  return {
    session: state.session,
    editMode: toEdit,
    initialValues: initVals,
    courseLessonModal: state.courseLessonModal,
    interests: state.interests,
    allUnpublishedCourseList: state.allUnpublishedCourseList,
    chapters,
    lessons,
    currentChapterOpen: state.currentChapterOpen,
    tempChapterRanking: state.tempChapterRanking,
  };
}

export default connect(mapStateToProps, {
  fetchQuiz,
  handleLessonModal,
  courseCurrentChapterOpen,
  updateTemporaryChapterRanking,
  updateSortedChapter,
  fetchAllUnpublishedCourses,
  showError,
  showSuccess,
})(CourseLessonsDetails);
